<div class="td-json-formatter-wrapper">
    <a [class.td-key-node]="isExpandable"
       [class.td-key-leaf]="!isExpandable"
       [tabIndex]="isObject()? 0 : -1"
       (keydown.enter)="toggle()"
       (click)="toggle()"
       class="td-key"
       layout="row"
       layout-align="start center">
        <mat-icon class="tc-grey-600"
                  *ngIf="isExpandable">{{ open ? 'keyboard_arrow_down' : (isRTL ? 'keyboard_arrow_left' : 'keyboard_arrow_right') }}</mat-icon>
        <span *ngIf="key"
              class="key">
            {{key}}:
        </span>
        <span class="value">
            <span *ngIf="isObject()"
                  [class.td-empty]="isEmpty()">
                <span *ngIf="!isEmpty(); else emptyObjectLabel">
                    {{getObjectName()}}
                </span>
                <ng-template #emptyObjectLabel>
                    {{emptyPlaceholder}}
                </ng-template>
                <span *ngIf="isArray() &&
                            !!data.length">
                    [{{data.length}}]
                </span>
            </span>
            <ng-container *ngIf="!!template &&
                                 !isObject()">
                <ng-container *ngTemplateOutlet="template; context: { $implicit: {
                    value: getValue(data),
                    type: getType(data),
                    key: key
                } }">
                </ng-container>
            </ng-container>
            <span *ngIf="!template &&
                         !isObject()"
                  [class]="getType(data)"
                  [class.td-empty]="isEmpty()">
                <span *ngIf="!isEmpty(); else emptyNonObjectLabel">
                    {{getValue(data)}}
                </span>
                <ng-template #emptyNonObjectLabel>
                    {{emptyPlaceholder}}
                </ng-template>
            </span>
        </span>
    </a>
    <div [hidden]="!(isExpandable && open)"
         class="td-object-children">
        <ng-template [ngForOf]="children"
                     ngFor
                     let-key>
            <ui-json-formatter [key]="key"
                               [data]="data[key]"
                               [levelsOpen]="levelsOpen - 1"
                               [objectPlaceholder]="objectPlaceholder"
                               [emptyPlaceholder]="emptyPlaceholder"
                               [template]="template">
            </ui-json-formatter>
        </ng-template>
    </div>
</div>
